class ModifierLabel {
    
    getLabels() {
        let labels = [];
        let colorGroup = QX7Rule.materialColorGroups

        _.each(colorGroup, group => {
            let groupName = group["Body Part Group"];
            let groupParts = group["Body Parts"];
            let allowPattern = group["Allow Patterns"];
            let allowSublimation = group["Allow Sublimation"];
            let hasColorSet = _.find(QX7Rule.materialColorSets, {"body part": groupName})

            labels.push({
                name: groupName,
                code: groupName.toCodeCase(),
                parts: groupParts,
                colors: _.isUndefined(hasColorSet) || (ub.current_material.material.factory_code === 'QTS' && groupName === 'Sublimated Panel') ? ub.current_material.settings.team_colors : hasColorSet.colors,
                allowPattern,
                allowSublimation,
            });
        })

        return labels;
    }
}